<template>
  <div class="home">
    <section class="joint-assessment">
      <!-- <img v-for="item in banners" :key="item.imgUrl" :src="item.imgUrl" alt="" class="pointer" @click="$router.push('/race')">
      <img src="../assets/images/www-race-banner.png" class="pointer" alt="" @click="$router.push('/race')"> -->
    </section>
    <section class="zxhx">
      <div class="title-box">
        <h2 class="title">进一步了解知心慧学</h2>
        <i class="border-bottom"></i>
      </div>
      <div class="content">
        <div class="top clearfix">
          <div class="images fl">
            <img src="../assets/img/img-ywfw.png" alt="业务范围">
          </div>
          <div class="text fr">
            <h3 class="ywfw">我们的业务范围</h3>
            <p>
              知心慧学一直致力于互联网教育领域的产品研发，着力于用大数据及人工智能等信息技术提升教育的质量与效率。与基础教育学校一道，努力探索让信息技术深度融入于学校教学，在互联网+的大时代背景下推动学校的转型与发展。</p>
          </div>
        </div>
        <div class="bottom clearfix">
          <div class="text fl">
            <h3 class="sjwj">强大的数据挖掘能力</h3>
            <p>
              知心慧学强大的数据挖掘与分析能力是实现个性化、精准化教学的基础与保障。我们将每个教师、每个学生、每场考试的过程数据收集记录下来，将每次鼠标点击、每道试题的分数转化为清晰的个人能力模型和精准的学情分析报告。</p>
          </div>
          <div class="images fr">
            <img src="../assets/img/img-sjwj.png" alt="数据挖掘">
          </div>
        </div>
      </div>
    </section>
    <section class="jjfa">
      <div class="title-box">
        <h2 class="title">知心慧学基于测评大数据的解决方案</h2>
        <i class="border-bottom"></i>
      </div>
      <div class="content">
        <div class="card gstg">
          <div class="card-in">
            <div class="card-front">
              <div class="card-title">
                <h4 class="text">公司提供</h4>
              </div>
            </div>
            <div class="card-back">
              <p><em class="sign">·</em>周期作业、月度测评、学业评估的分析报告及错题本、个性化学习宝。基于大数据分析的网络课（每学期平时5次双师课，师生共同学习）
                基于大数据分析的典型课（对学生 假期15次）
                基于大数据分析个性化典型问题的微课、闯关训练</p>
              <p><em class="sign">·</em>专职学管，负责数据采集及打印试卷、错题本、个性化学习宝等服务</p>
              <p><em class="sign">·</em>办公电脑、大型扫描仪、打印机</p>
              <p><em class="sign">·</em>知心慧学大数据教育系统</p>
            </div>
          </div>
        </div>
        <div class="card falj">
          <div class="card-in">
            <div class="card-front">
              <div class="card-title">
                <h4 class="text">方案逻辑</h4>
              </div>
            </div>
            <div class="card-back">
              <p><em class="sign">·</em>测试数据采集</p>
              <p><em class="sign">·</em>测试数据分析</p>
              <p><em class="sign">·</em>线下个性化训练方案</p>
              <p><em class="sign">·</em>线上网络方案</p>
              <p><em class="sign">·</em>线上典型考点微课学习及闯关训练</p>
            </div>
          </div>
        </div>
        <div class="card xxtg">
          <div class="card-in">
            <div class="card-front">
              <div class="card-title">
                <h4 class="text">学校提供</h4>
              </div>
            </div>
            <div class="card-back">
              <p><em class="sign">·</em>大数据中心（学管办公室，30~60平方米，通电、通网）</p>
              <p><em class="sign">·</em>PAD学习教室（1~2间，每间50~60个座位，通电、通网）</p>
            </div>
          </div>
        </div>
        <div class="card lszsm">
          <div class="card-in">
            <div class="card-front">
              <div class="card-title">
                <h4 class="text">老师做什么</h4>
              </div>
            </div>
            <div class="card-back">
              <p><em class="sign">·</em>检查学校生成错题本、个性化学习宝的情况</p>
              <p><em class="sign">·</em>组织学生参加网络双师课，并对学生进行指导</p>
              <p><em class="sign">·</em>组织学生参加PAD微课学习，并随堂指导讲解</p>
              <p><em class="sign">·</em>参加网络研修，学习方法、技巧，提升教学能力</p>
            </div>
          </div>
        </div>
        <div class="card xszsm">
          <div class="card-in">
            <div class="card-front">
              <div class="card-title">
                <h4 class="text">学生做什么</h4>
              </div>
            </div>
            <div class="card-back">
              <p><em class="sign">·</em>看分析报告了解薄弱点</p>
              <p><em class="sign">·</em>完成错题本、个性化学习宝</p>
              <p><em class="sign">·</em>通过网络学习</p>
              <p><em class="sign">·</em>运用PAD学习薄弱考点微课，并完成闯关训练</p>
            </div>
          </div>
        </div>
        <div class="card ldzsm">
          <div class="card-in">
            <div class="card-front">
              <div class="card-title">
                <h4 class="text">领导做什么</h4>
              </div>
            </div>
            <div class="card-back">
              <p><em class="sign">·</em>校长或年级主任主抓，制定奖惩制度</p>
              <p><em class="sign">·</em>制定考练计划，统一考试，统一阅卷</p>
              <p><em class="sign">·</em>及时反馈，及时讲评</p>
              <p><em class="sign">·</em>组织学生学习pad课程</p>
            </div>
          </div>
        </div>

      </div>
    </section>
    <section class="cpzx">
      <div class="title-box">
        <h2 class="title">产品中心</h2>
        <i class="border-bottom"></i>
      </div>
      <div class="content">
        <div class="products-description">
          <div v-show="productsType==1" class="description-box">
            <div class="name-wrap">
              <span class="name">个性化学习宝</span>
              <i class="triangle"></i>
            </div>
            <div class="text-big">
              <p>查漏补缺，举一反三，触类旁通，快速掌握</p>
            </div>
            <div class="text-min">
              <p>量身定制个性化训练方案， 查缺补漏，举一反三，避免学生盲目训练，方便纠错学习。</p>
            </div>
          </div>
          <div v-show="productsType==2" class="description-box">
            <div class="name-wrap">
              <span class="name">错题本</span>
              <i class="triangle"></i>
            </div>
            <div class="text-big">
              <p>每天20至30分钟提升学习效率</p>
            </div>
            <div class="text-min">
              <p>明晰自身学习的缺漏与不足，瞄准目标与方向。节省抄写的时间精力，保留作答原笔迹，提高回顾学习效率。</p>
            </div>
          </div>
          <div v-show="productsType==3" class="description-box">
            <div class="name-wrap">
              <span class="name">教学宝</span>
              <i class="triangle"></i>
            </div>
            <div class="text-big">
              <p style="letter-spacing: -2px">打印整合成册，让老<br/>师学生“教”“学”更方便”</p>
            </div>
            <div class="text-min">
              <p>将答题详情、学情统计、学生成绩动态跟踪表、班级变式训练题等整理成册帮助教师科学备课、精准讲评、个性化授课。</p>
            </div>
          </div>
          <div v-show="productsType==4" class="description-box">
            <div class="name-wrap">
              <span class="name">教研网</span>
              <i class="triangle"></i>
            </div>
            <div class="text-big">
              <p>同步教研资源，骨干教师在线直播</p>
            </div>
            <div class="text-min">
              <p>针对教师教学当中遇到的教材分析、教学目标、教学设计、学法指导、特色创新、课时作业设计等实际问题，开展在线互动讲座，帮助教师在备课、上课和布置训练时开阔视野，点拨思维。</p>
            </div>
          </div>
        </div>
        <div class="products-img">
          <div class="img-big">
            <img v-show="productsType==1" src="../assets/img/img-products-1.png" alt="">
            <img v-show="productsType==2" src="../assets/img/img-products-2.png" alt="">
            <img v-show="productsType==3" src="../assets/img/img-products-3.png" alt="">
            <img v-show="productsType==4" src="../assets/img/img-products-4.png" alt="">
            <div class="arrow-left" @click="productsLeft">
              <img src="../assets/img/img-arrow-left.png" alt="">
            </div>
            <div class="arrow-right" @click="productsRight">
              <img src="../assets/img/img-arrow-right.png" alt="">
            </div>
          </div>
          <div class="img-min">
            <img :class="{'active' : productsType === 1 }" @click="productsType=1"
                 src="../assets/img/img-products-1.png" alt="">
            <img :class="{'active' : productsType === 2 }" @click="productsType=2"
                 src="../assets/img/img-products-2.png" alt="">
            <img :class="{'active' : productsType === 3 }" @click="productsType=3"
                 src="../assets/img/img-products-3.png" alt="">
            <img :class="{'active' : productsType === 4 }" @click="productsType=4"
                 src="../assets/img/img-products-4.png" alt="">
          </div>
        </div>
      </div>
    </section>
<!--    <section class="fgfw">-->
<!--      <div class="title-box">-->
<!--        <h2 class="title">持续覆盖全国 让更多学校受益</h2>-->
<!--        <i class="border-bottom"></i>-->
<!--      </div>-->
<!--      <div class="content">-->
<!--        <p class="text">帮助教师减轻教学负担，帮助学生提高学习效率</p>-->
<!--        <div class="user">-->
<!--          <div class="user-number">-->
<!--            <span>当前有</span>-->
<!--            <div class="number">-->
<!--              <span class="number-item" v-for="i in usageQuantity.user">{{i}}</span>-->
<!--            </div>-->
<!--            <span>名师生</span>-->
<!--          </div>-->
<!--          <p class="msg">正在使用知心慧学</p>-->
<!--        </div>-->
<!--        <div>-->
<!--          <div class="record-box record-left">-->
<!--            <p>老师组卷记录</p>-->
<!--            <div class="number">-->
<!--              <span class="number-item" v-for="i in usageQuantity.test" :class="{'update' : i.roll==1}">{{i.value}}</span>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="record-box record-right">-->
<!--            <p>学生考试次数</p>-->
<!--            <div class="number">-->
<!--              <span class="number-item" v-for="i in usageQuantity.examination" :class="{'update' : i.roll==1}">{{i.value}}</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
    <!-- <section class="hzxx">
      <div class="title-box">
        <h2 class="title">深度合作学校</h2>
        <i class="border-bottom"></i>
      </div>
      <div class="content">
        <img src="../assets/images/s-logo-1.png" alt="">
        <img src="../assets/images/s-logo-2.png" alt="">
        <img src="../assets/images/s-logo-3.png" alt="">
        <img src="../assets/images/s-logo-4.png" alt="">
        <img src="../assets/images/s-logo-5.png" alt="">
        <img src="../assets/images/s-logo-6.png" alt="">
        <img src="../assets/images/s-logo-7.png" alt="">
        <img src="../assets/images/s-logo-8.png" alt="">
        <img src="../assets/images/s-logo-9.png" alt="">
        <img src="../assets/images/s-logo-10.png" alt="">
        <img src="../assets/images/s-logo-11.png" alt="">
        <img src="../assets/images/s-logo-12.png" alt="">
        <img src="../assets/images/s-logo-13.png" alt="">
        <img src="../assets/images/s-logo-14.png" alt="">
        <img src="../assets/images/s-logo-15.png" alt="">
        <img src="../assets/images/s-logo-16.png" alt="">


      </div>
    </section> -->
    <section class="gstd">
      <div class="title-box">
        <h2 class="title">我们的团队</h2>
        <i class="border-bottom"></i>
      </div>
      <div class="content">
        <div class="card-box">
          <div class="card">
            <img src="../assets/img/img-fwtd.png" alt="">
            <p class="name">服务团队</p>
          </div>
          <div class="card">
            <img src="../assets/img/img-yftd.png" alt="">
            <p class="name">研发团队</p>
          </div>
          <div class="card">
            <img src="../assets/img/img-jstd.png" alt="">
            <p class="name">技术团队</p>
          </div>
        </div>
        <p class="text">
          风向标科技拥有强大的技术实力，在上海和南昌分别设立技术中心，拥有专职技术人员近百名，多人拥有海外上市技术公司的管理经验，团队服务过的在线测评、大数据分析处理的用户级别达千万。风向标技术团队始终紧跟前沿技术，技术的延伸性和先进性有机结合，形成了真正可靠稳定的技术优势，在大数据和人工智能领域都有专业建树。</p>
      </div>
    </section>


    <section class="login-wrap">
      <Login></Login>
    </section>

  </div>
</template>

<script>
  import Login from '@/components/Login'
  import Http from '../lib/Http';
  export default {
    name: "Home",
    components: {
      Login
    },
    data() {
      return {
        productsType: 1,
        usageQuantity: {
          user: [0, 1, 2, 3, 4, 5, 6, 7],
          test: [{value:0,roll:0},{value:1,roll:0}, {value:2,roll:0},{value:3,roll:0},{value:4,roll:0},{value:5,roll:0},{value:6,roll:0},{value:7,roll:0}],
          examination: [{value:0,roll:0},{value:1,roll:0}, {value:2,roll:0},{value:3,roll:0},{value:4,roll:0},{value:5,roll:0},{value:6,roll:0},{value:7,roll:0}],
        },
        numberItem:0,
        examinationVal:[],
        banners: [],
        testVal:[],
        isNight:false,
        userNum:3473528,
        testNum:568216,
        examinationNum:24650949,
        sameDay:'',
        time:'',
        y:2018,
        m:12,
        d:21,
        w:5,
      }
    },
    watch:{
      'examinationVal'(val, oldVal){
        for ( let i in val) {
          if(val[i] != oldVal[i]){
            this.usageQuantity.examination[i].roll =1
            let _this = this;
            setTimeout(function(){
              _this.usageQuantity.examination[i].roll =0
            }, 500);
          }
        }

      },
      'testVal'(val, oldVal){
        for ( let i in val) {
          if(val[i] != oldVal[i]){
            this.usageQuantity.test[i].roll =1
            let _this = this;
            setTimeout(function(){
              _this.usageQuantity.test[i].roll =0
            }, 500);
          }
        }
      }
    },
    created() {
      this.userNum=this.userNum+this.sum(60,10);
      this.getNowDate();
      this.editData();
      this.getData();
    },

    methods: {
      goJointAssess (item) {
        // this.$router.push("/signUpList")
        if(item.haveUrl) {
          location.href = item.url;
        }
      },
      getData() {
        Http.Axios.get(`${Http.API_ROOT()}business/banner/home `).then(res => {
          this.banners = res.data.data;
        })
      },
      editData(){
        let _this = this;
        this.setTestNum(this.sameDay,this.time,this.y);
        this.setExaminationNum(this.sameDay,this.time,this.y);

        setInterval(function(){_this.getNowDate()},1000);

        setInterval(function(){
          _this.setTestNum(_this.sameDay,_this.time,_this.y);
        },5000);
        setInterval(function(){
          _this.setExaminationNum(_this.sameDay,_this.time,_this.y);
        },30000);

        this.setUserNum(this.sameDay,this.y);
      },
      // 产品显示切换
      productsLeft() {
        this.productsType = this.productsType - 1;
        if (this.productsType == 0) {
          this.productsType = 4;
        }
      },
      productsRight() {
        this.productsType = this.productsType + 1;
        if (this.productsType == 5) {
          this.productsType = 1;
        }
      },
      //随机数
      sum (m,n){
        let num = Math.floor(Math.random()*(m - n) + n);
        return num
      },
      //使用知心慧学数量
      getNowDate() {
        let date = new Date();
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        if(m<10){
          m = '0'+m
        }
        let d = date.getDate();
        if(d<10){
          d = '0'+d
        }
        let h = date.getHours();
        if(h<7 || h>20){
          this.isNight =true;
        }
        if(h<10){
          h = '0'+h
        }
        let i = date.getMinutes();
        if(i<10){
          i = '0'+i
        }
        let s = date.getSeconds();
        if(s<10){
          s = '0'+s
        }
        let w = date.getDay();

        this.sameDay = y.toString()+m.toString()+d.toString();
        this.time = h.toString()+i.toString()+s.toString();
        this.y = y;
        this.m = m;
        this.d = d;
        this.w = w;
      },
      setUserNum(sameDay,y){
        //师生量
        let userVal2 = (Number(sameDay)*4/9)+((y-2018)*100000)+this.userNum;
        let userVal3 = Math.round(userVal2).toString();
        let userVal = [];
        userVal = userVal3.split("");
        this.usageQuantity.user = userVal;
      },
      setTestNum(sameDay,time,y,w){
        //组卷数量
        let testVal2 = (Number(sameDay)/36)+((y-2018)*1024000)+Number(time)*2/9 +this.testNum;
        if(this.isNight){
          testVal2 = (Number(sameDay)/36)+((y-2018)*1024000)+Number(205959)*2/9 +this.testNum;
        }
        let testVal3 = Math.round(testVal2).toString();
        testVal3 ='0'+testVal3;
        this.testVal = testVal3.split("");
        for ( let x in this.testVal) {
          this.usageQuantity.test[x].value =this.testVal[x];
        }
      },
      setExaminationNum(sameDay,time,y){
        //考试数量
        let examinationVal2 = (Number(sameDay)/5)+((y-2018)*2048000)+Number(time)*2/3 +this.examinationNum;

        if (sessionStorage.examinationVal2) {
          let v = sessionStorage.examinationVal2;
          v = Number(v);
          let s = this.sum(23,11);
          examinationVal2= v+s;
        }
        sessionStorage.examinationVal2 = examinationVal2;
        if(this.isNight){
          examinationVal2 =(Number(sameDay)/5)+((y-2018)*2048000)+Number(205959)*2/3+this.examinationNum;
        }
        let examinationVal3 = Math.round(examinationVal2).toString();
        this.examinationVal = examinationVal3.split("");

        for ( let x in this.examinationVal) {
          this.usageQuantity.examination[x].value =this.examinationVal[x];
        }
      },
    }
  }
</script>

<style scoped lang="less">

  @highlight-border: #3ECDBAFF;
  @highlight-background: #50d2c2;

  .highlight-border {
    border-bottom: 2px solid @highlight-border;
  }

  .home {
    position: relative;
    background-color: #fff;
    .login-wrap {
      position: absolute;
      width: 1200px;
      top: -451px;
      left: calc(50% - 600px);
      background-color: #fff;
      border-radius: 4px;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
    }
  }

  .title-box {
    .title {
      line-height: 56px;
      font-size: 40px;
      text-align: center;
      color: #333;
    }
    .border-bottom {
      display: block;
      margin: 0 auto;
      padding-top: 16px;
      width: 40px;
      border-bottom: 4px solid @highlight-border;
    }
  }

  .pointer{
    cursor: pointer;
    height: 220px;
  }
  .joint-assessment {
    margin-top: 366px;
    img{
      width: 100%;
      min-width: 1200px;
    }
  }

  .zxhx {
    margin-top: 30px;
    padding: 80px 0;
    background-color: #fafafa;
    .content {
      width: 1200px;
      margin: 0 auto;
      .top, .bottom {
        margin-top: 40px;
      }
      .images {
        width: 500px;
        height: 291px;
        /*border: 1px dashed #888;*/
      }
      .text {
        width: 580px;
        h3 {
          margin-top: 40px;
          margin-bottom: 20px;
          font-size: 30px;
          color: #333;
        }
        .ywfw {
          padding-left: 33px;
          background: url("../assets/img/bg-1.png") no-repeat 0;
          background-size: 19px;
        }
        .sjwj {
          padding-left: 40px;
          background: url("../assets/img/bg-2.png") no-repeat 0;
          background-size: 26px;
        }
        p {
          line-height: 40px;
          font-size: 18px;
          color: #333;
        }
      }
    }
  }

  .jjfa {
    padding: 80px 0;
    .content {
      width: 1200px;
      height: 598px;
      margin: 0 auto;
      padding-top: 80px;
      display: flex;
      flex-wrap: wrap;
      align-content: space-between;
      justify-content: space-between;
      .gstg {
        background-image: url("../assets/img/img-gstg.png");
      }
      .falj {
        background-image: url("../assets/img/img-falj.png");
      }
      .xxtg {
        background-image: url("../assets/img/img-xxtg.png");
      }
      .lszsm {
        background-image: url("../assets/img/img-lszsm.png");
      }
      .xszsm {
        background-image: url("../assets/img/img-xszsm.png");
      }
      .ldzsm {
        background-image: url("../assets/img/img-ldzsm.png");
      }
      .card {
        width: 380px;
        height: 284px;
        z-index: 2;
        .card-in {
          position: relative;
          font-size: 18px;
          .card-back,
          .card-front {
            width: 380px;
            height: 284px;
            backface-visibility: hidden;
            transition: all 0.3s ease
          }
          .card-front {
            /*padding: 40px;*/
            /*background-color: rgba(255, 255, 255, .8);*/
            background-opacity: 0.4;
            .card-title {
              display: block;
              .text {
                line-height: 284px;
                font-size: 30px;
                text-align: center;
                color: #FDFDFD;
              }
            }
          }
          .card-back {
            /*padding: 40px 20px;*/
            position: absolute;
            top: 0;
            left: 0;
            transform: rotateY(180deg);
            z-index: 0;
            background: rgba(80, 210, 194, 0.9);
            p {
              margin-top: 10px;
              padding: 0 10px;
              line-height: 22px;
              font-size: 16px;
              color: #fff;
              text-align: justify;
            }
            .sign {
              font-style: italic;
              margin-right: 4px;
              line-height: 22px;
            }
          }
        }
        &:hover .card-front {
          transform: rotateY(180deg);
          z-index: 0
        }
        &:hover .card-back {
          transform: rotateY(360deg);
          z-index: 10
        }
      }
    }
  }

  .cpzx {
    padding-top: 80px;
    background-color: #fafafa;
    .content {
      position: relative;
      width: 1200px;
      height: 580px;
      margin: 0 auto;
      margin-top: 80px;
      padding-bottom: 80px;
      .products-description {
        position: absolute;
        left: 0;
        top: 0;
        width: 380px;
        .description-box {
          .name-wrap {
            width: 145px;
            line-height: 60px;
            font-size: 30px;
            text-align: center;
            .name {
              display: block;
              width: 190px;
              color: #fff;
              background-color: @highlight-background;
            }
            .triangle {
              display: block;
              margin: 0 auto;
              width: 0;
              height: 0;
              border-left: 10px solid transparent;
              border-right: 10px solid transparent;
              border-top: 12px solid @highlight-background;
            }

          }
          .text-big {
            font-family: Serif;
            margin-top: 40px;
            line-height: 56px;
            font-size: 40px;
            color: #333;
            text-align: left;
          }
          .text-min {
            margin-top: 40px;
            line-height: 40px;
            font-size: 20px;
            color: #333;
          }
        }
      }
      .products-img {
        position: absolute;
        right: 0;
        top: 0;
        width: 784px;
        .img-big {
          display: inline-block;
          position: relative;
          width: 580px;
          margin-right: 20px;
          > img {
            width: 580px;
          }
          .arrow-left, .arrow-right {
            position: absolute;
            top: 265px;
            width: 60px;
            height: 50px;
            cursor: pointer;
          }
          .arrow-left {
            left: 0;
          }
          .arrow-right {
            right: 0;
          }
        }
        .img-min {
          display: inline-block;
          width: 180px;
          font-size: 0;
          img {
            width: 180px;
            height: 130px;
            margin-bottom: 20px;
            cursor: pointer;
            border-bottom: 4px solid #fff;
            box-sizing: border-box;
            &:last-child {
              margin-bottom: 0;
            }
          }
          .active {
            border-bottom: 4px solid @highlight-border;
          }
        }
      }
    }
  }

  .fgfw {
    padding-top: 80px;
    .content {
      width: 1200px;
      margin: 0 auto;
      padding-bottom: 206px;
      background: url("../assets/img/bg-map.png") center no-repeat;
      /*background-size:974px 809px;*/
      .text {
        margin-top: 40px;
        margin-bottom: 80px;
        line-height: 26px;
        font-size: 20px;
        color: #666;
        text-align: center;
      }
      .user {
        text-align: center;
        .user-number {
          font-size: 20px;
          color: #333;
          line-height: 73px;

        }
        .msg {
          margin-top: 40px;
          margin-bottom: 80px;
          font-size: 40px;
          color: #333;
        }
      }
      .record-box {
        display: inline-block;
        width: 580px;
        height: 216px;
        > p {
          margin-top: 40px;
          margin-bottom: 20px;
          font-size: 20px;
          line-height: 28px;
          text-align: center;
          color: #333;
        }
        .number {
          margin-left: 84px;
        }
      }
      .record-left {
        margin-right: 20px;
        background: url("../assets/img/bg-record-left.png") no-repeat;
      }
      .record-right {
        background: url("../assets/img/bg-record-right.png") no-repeat;
      }
      .number {
        display: inline-block;
        margin-left: 20px;
        margin-right: 16px;
        .number-item {
          display: inline-block;
          width: 48px;
          height: 73px;
          line-height: 73px;
          margin-right: 4px;
          font-size: 40px;
          color: #fff;
          background: url("../assets/img/bg-number-item.png");
          text-align: center;
        }
        .update{
          transform: rotateX(360deg);
          transition: transform .5s;
        }

      }
    }
  }

  .hzxx {
    padding-top: 80px;
    height: 736px;
    background: url("../assets/img/bg-hzxx.png") center no-repeat;
    box-sizing: border-box;
    .title {
      color: #fff;
    }
    .content {
      width: 1200px;
      height: 500px;
      margin: 0 auto;
      padding-top: 40px;
      display: flex;
      flex-wrap: wrap;
      align-content: space-between;
      justify-content: space-between;
    }

  }

  .gstd {
    padding-top: 80px;
    .content {
      width: 1200px;
      margin: 0 auto;
      padding-top: 70px;
      padding-bottom: 80px;
      background: url("../assets/img/bg-map.png") center no-repeat;
      .card-box {
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        justify-content: space-between;
        .card {
          width: 380px;
          background-color: #fff;
          box-shadow: 0px 0px 36px 0px rgba(238, 238, 238, 1);
          .name {
            line-height: 70px;
            font-size: 20px;
            text-align: center;
            color: #333;
          }
        }
      }
      .text {
        margin-top: 80px;
        font-size: 18px;
        line-height: 30px;
        text-indent: 2em;
        color: #666;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Home.vue?73fc3db0